import { useState, useEffect } from 'react';
import { getBanner } from '../../api-route/baner';
import ArtistsSection from '../../Components/artists-section/index';
import HeroHeader from '../../Components/hero-header-section/index.section';
const Artists = () => {
    const [texts, setTexts] = useState({ baner: [] })
    useEffect(() => {
        const get = async () => {
            const data = await getBanner(3)
            setTexts(data ? data : {})
        }
        get()
    }, []);
    return (
        <>
            <main className="flex flex-col">
                <HeroHeader {...texts} breadcrumb={[{ slug: 'artists', name: 'هنرمندان' }]} />
                <ArtistsSection head1={texts?.header3} head2={texts?.header4} />
            </main>
        </>
    );
};

export default Artists;